import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Propertybookingpdf } from "../../Services/Service";

export const fetchVoucherDetails = createAsyncThunk(
  "voucher/fetchVoucherDetails",
  async (BONRESID) => {
    const response = await Propertybookingpdf(BONRESID);
    return response;
  }
);

const voucherSlice = createSlice({
  name: "voucher",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoucherDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVoucherDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchVoucherDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default voucherSlice.reducer;